import { render } from "./Artist.vue?vue&type=template&id=52f505ca&scoped=true&ts=true"
import script from "./Artist.vue?vue&type=script&lang=ts"
export * from "./Artist.vue?vue&type=script&lang=ts"

import "./Artist.vue?vue&type=style&index=0&id=52f505ca&lang=scss&scoped=true"

import exportComponent from "C:\\bonch\\okimi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f505ca"]])

export default __exports__